module.exports = __webpack_public_path__ + "img/icon-data.f9b264e2.png";